import React from 'react';
import {Container} from 'react-bootstrap';
import './AddNewWireTemplate.css';

const STEP_LABELS = [
    'Template Information',
    'Creditor Agent',
    'Creditor',
    'Debtor',
    'Intermediary Agent',
    'Summary',
];

/**
 * Shared chrome (stepper + heading + bounded container) for the
 * 7 AddNewWireTemplate steps. Uses TD-conformant Bootstrap markup
 * and TD color (#008A00) — no custom fonts/gradients.
 */
export default function WireTemplateWizardLayout({
                                                     currentStep,
                                                     stepTitle,
                                                     showCounter = true,
                                                     children,
                                                 }) {
    return (
        <Container fluid className="awt-wizard">
            <ol className="awt-stepper" aria-label="Wire template progress">
                {STEP_LABELS.map((label, index) => {
                    const stepNum = index + 1;
                    const stateClass =
                        stepNum < currentStep ? 'awt-stepper__item--done'
                            : stepNum === currentStep ? 'awt-stepper__item--current'
                                : '';
                    return (
                        <li
                            key={label}
                            className={`awt-stepper__item ${stateClass}`}
                            aria-current={stepNum === currentStep ? 'step' : undefined}
                        >
                            <span className="awt-stepper__num">{stepNum}</span>
                            <span className="awt-stepper__label">{label}</span>
                        </li>
                    );
                })}
            </ol>

            <div className="awt-header">
                <h2 className="awt-header__title">
                    {showCounter && (
                        <small>Step {currentStep} of 6 —</small>
                    )}
                    {stepTitle}
                </h2>
                <span className="awt-header__secure">
                    <i className="bi bi-lock-fill"/>
                    Secure Application
                </span>
            </div>

            <div className="awt-form">
                {children}
            </div>
        </Container>
    );
}

